// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"QuickDepositButton_buttonWrapper--iZQ","depositButton":"QuickDepositButton_depositButton--Bis"};